const clientdetails = (state = [], action) => {
    switch (action.type) {
      case 'DETAILS':
      return {
          type: "DETAILS",
          details: action.details
        }
      default:
        return state
    }
  }
  
  export default clientdetails